import React from "react";
import styles from "./MainSlider.module.scss";
import { IImage } from "../../../models/IImage";

interface MainSliderProps {
  images: IImage[];
}

const MainSlider: React.FC<MainSliderProps> = ({ images }) => {
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const [startX, setStartX] = React.useState(0);
  const [isDragging, setIsDragging] = React.useState(false);
  const [offset, setOffset] = React.useState(0);


  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    setIsDragging(true);
    setStartX(e.clientX);
  };
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isDragging) return;
    const movedX = e.clientX - startX;
    setOffset(movedX);

    if (movedX > 200) {

      setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
      setIsDragging(false);
    } else if (movedX < -200) {

      setCurrentSlide((prev) => (prev + 1) % images.length);
      setIsDragging(false);
    }
  };
  const handleMouseUp = () => {
    setIsDragging(false);
    setOffset(0);
  };

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    setIsDragging(true);
    setStartX(e.touches[0].clientX);
  };
  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    if (!isDragging) return;
    const movedX = e.touches[0].clientX - startX;
    setOffset(movedX);

    if (movedX > 30) {

      setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
      setIsDragging(false);
    } else if (movedX < -30) {

      setCurrentSlide((prev) => (prev + 1) % images.length);
      setIsDragging(false);
    }
  };
  const handleTouchEnd = () => {
    setIsDragging(false);
    setOffset(0);
  };

  return (
    <div className={styles.slider}>
      <div
        className={styles.body}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        style={{
          transform: `translateX(${offset}px)`,
          transition: isDragging ? "none" : "transform 0.3s",
        }}
      >
        {images.length !== 0
          ? images.map((image, index) => {
              const urlsLength = image.imgUrls.length;
              return (
                <React.Fragment key={image.id}>
                  <div
                    className={
                      urlsLength === 1
                        ? `${styles.item} ${styles.oneLenght}`
                        : urlsLength === 2
                        ? `${styles.item} ${styles.twoLenght}`
                        : urlsLength === 3
                        ? `${styles.item} ${styles.threeLenght}`
                        : styles.item
                    }
                    key={image.id}
                    style={{ transform: `translateX(${-100 * currentSlide}%)`, transition: "transform 0.3s" }}
                  >
                    <div className={styles.left}>
                      <img src={image.imgUrls[0]} alt="" />
                    </div>
                    <div className={styles.right}>
                      <div className={styles.top}>
                        {urlsLength > 1 && (
                          <div className={styles.part}>
                            <img src={image.imgUrls[1]} alt="" />
                          </div>
                        )}
                        {urlsLength > 2 && (
                          <div className={styles.part}>
                            <img src={image.imgUrls[2]} alt="" />
                          </div>
                        )}
                      </div>
                      {urlsLength === 4 && (
                        <div className={styles.bottom}>
                          <img src={image.imgUrls[3]} alt="" />
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    style={{ transform: `translateX(${-100 * currentSlide}%)`, transition: "transform 0.3s" }}
                    className={styles.bigImage}
                  >
                    <img src={image.imgUrls[0]} alt="" />
                  </div>
                </React.Fragment>
              );
            })
          : ""}
      </div>
      <div className={styles.pagination}>
        {images.map((_, index) => (
          <button key={index} onClick={() => setCurrentSlide(index)}>
            {currentSlide === index ? (
              <div className={styles.currentSlide}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <circle cx="12" cy="12" r="12" fill="currentColor" />
                </svg>
              </div>
            ) : (
              <div className={styles.notCurrentSlide}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <circle cx="12" cy="12" r="12" fill="currentColor" />
                </svg>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MainSlider;
